'use client'

import HeaderGap from '@/components/atoms/headerGap'
import Spacer from '@/components/atoms/spacer'
import ResponsiveTitle from '@/components/molecules/responsiveTitle'
import Container from '@/components/templates/container'
import Layout from '@/components/templates/layout'
import Info from './components/info'
import Form from './components/form'

const ContactPage = ({ contactAPI, footerAPI, settingAPI }) => {
  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <HeaderGap />
      <Container outerClassName="mt-[100px] lg:mt-[110px]">
        <ResponsiveTitle
          left={contactAPI.heading.left}
          center={contactAPI.heading.center}
          right={contactAPI.heading.right}
          size="small"
        />
      </Container>
      <Container outerClassName="mt-smallMobile lg:mt-smallDesktop">
        <Spacer />
        <Info info={contactAPI.info} />
      </Container>
      <Container
        outerClassName="mt-largeMobile lg:mt-largeDesktop mb-largeMobile lg:mb-mediumDesktop"
        className="flex flex-col"
      >
        <ResponsiveTitle
          left={contactAPI.formTitle.left}
          center={contactAPI.formTitle.center}
          right={contactAPI.formTitle.right}
          size="small"
          className="mb-smallMobile lg:mb-smallDesktop"
        />
        <Spacer />
        <Form />
      </Container>
    </Layout>
  )
}

export default ContactPage
